import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "13",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.5 6.125C13.5 5.58594 13.1953 5.09375 12.75 4.83594V1.27344C12.75 1.0625 12.5859 0.5 12 0.5C11.8125 0.5 11.6484 0.570312 11.5312 0.6875L9.51562 2.28125C8.53125 3.07812 7.26562 3.5 6 3.5H1.5C0.65625 3.5 0 4.17969 0 5V7.25C0 8.09375 0.65625 8.75 1.5 8.75H2.27344C2.25 9.00781 2.22656 9.26562 2.22656 9.5C2.22656 10.4375 2.4375 11.3281 2.83594 12.1016C2.95312 12.3594 3.21094 12.5 3.49219 12.5H5.22656C5.83594 12.5 6.21094 11.8203 5.83594 11.3281C5.46094 10.8125 5.22656 10.2031 5.22656 9.5C5.22656 9.24219 5.27344 9.00781 5.32031 8.75H6C7.26562 8.75 8.53125 9.19531 9.51562 9.99219L11.5312 11.5859C11.625 11.6797 11.8359 11.75 11.9766 11.75C12.5625 11.75 12.7266 11.2344 12.7266 11V7.4375C13.1953 7.17969 13.5 6.6875 13.5 6.125ZM11.25 9.45312L10.4531 8.82031C9.1875 7.8125 7.61719 7.25 6 7.25V5C7.61719 5 9.1875 4.46094 10.4531 3.45312L11.25 2.82031V9.45312Z" }, null, -1)
  ]))]))
}
export default { render: render }